import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Paper from '@material-ui/core/Paper';
import { DataGrid } from '@material-ui/data-grid';

import objectsSuggestedClient from '../../../../clients/objects-suggested';

import FilterSelectInput, { filters } from './components/FilterSelectInput';

const columns = [
  {
    field: 'id',
    headerName: 'Tipas',
    sortable: false,
    renderCell: (params) => {
      if (params?.row?.object){
        return 'Esamas'
      }
      return 'Naujas'
    }
  },
  {
    field: 'Title',
    headerName: 'Pavadinimas',
    flex: 1,
    sortable: false,
    renderCell: (params) => {      
      if (params?.row?.object){
        return params?.row?.object?.[params?.field]
      }
      return params?.formattedValue
    }
  },
];

const useStyles = makeStyles((theme) => ({
  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(1),

    '& > :not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const ObjectsList = () => {
  const classes = useStyles();

  const history = useHistory();
  const { path } = useRouteMatch();

  const { enqueueSnackbar } = useSnackbar();

  const [filter, setFilter] = useState(filters.ALL);

  const [objects, setObjects] = useState();

  useEffect(() => {
    (async () => {
      try {
        const query = { sort: 'createdAt:desc' };
        if (filter === filters.NEW) {
          query['filters[object][$null]'] = true;
        }
        if (filter === filters.EDIT) {
          query['filters[object][$null]'] = false;
        }
        setObjects(await objectsSuggestedClient.find(query));
      } catch (error) {
        enqueueSnackbar(
          'Nepavyko gauti objektų sąrašo. Bandykite atidaryti iš naujo.',
          { variant: 'error' }
        );
      }
    })();
  }, [filter, enqueueSnackbar]);

  const handleFilterChange = ({ target: { value } }) => setFilter(value);

  const handleNewObjectClick = () => history.push(`${path}/new`);

  const handleRowClick = ({ id }) => history.push(`${path}/${id}`);

  return (
    <div>
      <div className={classes.controls}>
        <FilterSelectInput
          label="Rodinys"
          value={filter}
          onChange={handleFilterChange}
        />
      </div>
      <Paper>
        <DataGrid
          columns={columns}
          rows={objects || []}
          loading={!objects}
          onRowClick={handleRowClick}
          autoHeight
          disableColumnMenu
          disableSelectionOnClick
        />
      </Paper>
    </div>
  );
};

export default ObjectsList;
